import { useEffect, useState } from "react";
import { GALLERY_MEDIA, VIDEO_FRAME_CAPTURE_TIME } from "./galleryData";

export default function useVideoThumbnails() {
  const [videoThumbnails, setVideoThumbnails] = useState({});

  useEffect(() => {
    let isCancelled = false;
    const activeVideos = [];

    const videoItems = GALLERY_MEDIA.filter((item) => item.type === "video");

    videoItems.forEach((item) => {
      const video = document.createElement("video");
      video.src = item.src;
      video.muted = true;
      video.playsInline = true;
      video.preload = "auto";
      video.crossOrigin = "anonymous";
      activeVideos.push(video);

      const cleanup = () => {
        video.pause();
        video.removeAttribute("src");
        video.load();
      };

      const captureFrame = () => {
        if (isCancelled) {
          cleanup();
          return;
        }
        if (!video.videoWidth || !video.videoHeight) {
          cleanup();
          return;
        }

        const canvas = document.createElement("canvas");
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;

        const context = canvas.getContext("2d");
        if (!context) {
          cleanup();
          return;
        }

        context.drawImage(video, 0, 0, canvas.width, canvas.height);

        setVideoThumbnails((current) => {
          if (current[item.src]) return current;
          return {
            ...current,
            [item.src]: canvas.toDataURL("image/webp", 0.82),
          };
        });

        cleanup();
      };

      video.addEventListener(
        "loadeddata",
        () => {
          if (isCancelled) return;
          const duration = Number.isFinite(video.duration) ? video.duration : 0;
          const targetTime =
            duration > VIDEO_FRAME_CAPTURE_TIME
              ? VIDEO_FRAME_CAPTURE_TIME
              : Math.min(duration / 2, 0.05);

          if (targetTime > 0) {
            video.currentTime = targetTime;
          } else {
            captureFrame();
          }
        },
        { once: true },
      );

      video.addEventListener(
        "seeked",
        () => {
          if (isCancelled) return;
          captureFrame();
        },
        { once: true },
      );

      video.addEventListener(
        "error",
        () => {
          cleanup();
        },
        { once: true },
      );

      video.load();
    });

    return () => {
      isCancelled = true;
      activeVideos.forEach((video) => {
        video.pause();
        video.removeAttribute("src");
        video.load();
      });
    };
  }, []);

  return videoThumbnails;
}
